<template>
    <BModal :model-value="modalFilter" title="Filter" centered @update:modelValue="updateModal"> 
      <template #header>
        <div class="d-flex align-items-center justify-content-between modal-title w-100">
          <h5 class="">Filter</h5>
        </div>
        <BButton
          variant="link"
          class="close"
          @click="updateModal(false)"
        >
          <i class="ion ion-android-close"></i>
        </BButton>
      </template>
      <BForm>
          <BRow>
              <BCol>
                  <div class="form-group">
                    
                    <BFormInput type="date">
                      
                    </BFormInput>
                  </div>
              </BCol>
              <BCol>
                  <div class="form-group">
                    <BFormInput type="date">
              
                    </BFormInput>
                  </div>
              </BCol>
          </BRow>
        <div class="form-group">
            <BFormInput type="text" placeholder="Search Guest Name">
            </BFormInput>
        </div>
        <div class="form-group">
          <BFormSelect v-model="selectedNoRoom" :options="no_rooms">
              <template #first>
              <BFormSelectOption :value="null" disabled>Select no room</BFormSelectOption>
            </template>
          </BFormSelect>
        </div>
       
      </BForm>
      <template #footer>
          <div class="d-flex justify-content-end">
              <BButton tton variant="light" @click="submitReservation" class="mr-2">Reset</BButton>
              <BButton variant="primary" @click="updateModal(false)">Filter</BButton>
          </div>
      </template>
    </BModal>
  </template>
  
  <script>
  import { ref } from 'vue';
  import { BRow, BCol, BModal, BForm, BFormSelect, BFormSelectOption, BButton, BFormInput, } from "bootstrap-vue-next";
  
  export default {
  
      name: 'RoomFilter',
      components: {
          BModal,
          BRow, 
          BCol,
          BButton,
          BFormInput,
          BForm, 
          BFormSelect, 
          BFormSelectOption,
      },
      props: {
          modalFilter: Boolean,
      },
      emits: ["update:modalFilter"],
      setup(props, {emit}){
          console.log(props)
          const selectedNoRoom = ref(null)
          const no_rooms = ref(['A1', 'A2', 'A3'])
          const updateModal = (value) => {
                  emit("update:modalFilter", value); // Sync modal state with parent
              };
          return{
              updateModal,
              selectedNoRoom,
              no_rooms,
          }
      }
      
  
  }
  </script>
  
  <style>
  
  </style>